<ng-container
*ngIf="'/login' !== this.currentUrl; then authenticate; else notauthenticated">
</ng-container>
<ng-template #notauthenticated>
<router-outlet></router-outlet>
</ng-template>
<ng-template #authenticate>

<ng-container
*ngIf="'/forgot-pass' !== this.currentUrl; then authenticate; else notauthenticated">
</ng-container>
<ng-template #notauthenticated>
<router-outlet></router-outlet>
</ng-template>
<ng-template #authenticate> 
<ng-container
*ngIf="'/event-details' !== this.currentUrl; then authenticate; else notauthenticated">
</ng-container>
<ng-template #notauthenticated>
<router-outlet></router-outlet>
</ng-template>
<ng-template #authenticate> 

<ng-container
*ngIf="'/change-pass' !== this.currentUrl; then authenticate; else notauthenticated">
</ng-container>
<ng-template #notauthenticated>
<router-outlet></router-outlet>
</ng-template>
<ng-template #authenticate>
<!-- change password end -->
<div class="wrapper" >
 <ngx-spinner
bdColor="rgba(51,51,51,0.8)"
size="medium"
color="#fff"
type="ball-scale-multiple"
>
<p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>
   <app-header></app-header>
   <app-sidebar ></app-sidebar>
 <div class="content-wrapper">
   <router-outlet></router-outlet>
 </div>  
  <app-footer></app-footer> 
</div>
</ng-template>


